import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { getResponseMessage } from '../../../../../../utils/utils';
import { getImportOffersFiles } from '../../../../../../crud/offer.crud';

export type ImportOffer = {
  company?: { id: number; name: string; brand: string };
  created_at: string;
  errors_num: number;
  id: number;
  offers_num: number;
  path: string;
  errors_xlsx_path: string | null;
  errors_path: string;
  deleted_num: number | null;
};

export const useGetImportFiles = () => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loadingOffers, setLoading] = useState(false);
  const [offers, setOffers] = useState<ImportOffer[] | null>(null);
  const [page, setPage] = useState({ page: 1, perPage: 20, total: 0 });

  const fetchImportOffers = useCallback(
    async (data: { page: number; per_page: number; errors?: boolean }) => {
      setLoading(true);
      getImportOffersFiles(data)
        .then((res: any) => {
          setOffers(res.data.data);
          // eslint-disable-next-line @typescript-eslint/naming-convention
          const { page, per_page, total } = res.data;
          setPage({ page, perPage: per_page, total });
        })
        .catch(e => {
          enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
            variant: 'error',
          });
        })
        .finally(() => {
          setLoading(false);
        });
    },
    []
  );

  return { fetchImportOffers, loadingOffers, offers, page };
};
